module.exports = __webpack_public_path__ + "img/treatment.b391890a.svg";